<div class="error" *ngIf="displayError">
  <span class="error__message">{{ errorMessage }}</span>
</div>
